module.exports = __webpack_public_path__ + "img/E-liquids.2c9dff3f.jpg";